import styled from "styled-components";
import { Text, Title } from 'theme/theme';
import { Type } from "theme/types";

export const DivTitleSelect = styled.div`
  ${({theme}: Type) => theme?.photographer?.start?.title?.div}
`

export const TitleSelect = styled(Title)`
  ${({theme}: Type) => theme?.photographer?.start?.title?.h1}
`

export const CardSelect = styled.div`
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid transparent;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }
  &:active {
    transform: translateY(0);
  }
  ${({theme}: Type) => theme?.photographer?.start?.card?.container}
`

export const CardSelectTitle = styled(Title)`
  font-size: 1.1rem;
  ${({theme}: Type) => theme?.photographer?.start?.card?.description}
`

export const CardSelectDescription = styled(Text)`
  font-size: 0.85rem;
  opacity: 0.8;
`

export const CardSelectImage = styled.img`
  width: 100%;
  height: 160px;
  object-fit: cover;
  ${({theme}: Type) => theme?.photographer?.start?.card?.img}
`
